define((require, exports, module) => {
    'use strict';

    /**
     * @param {HTMLElement} target
     * @returns {boolean}
     */
    function copyToClipboard(target) {
        if (!document.queryCommandSupported('copy')) {
            return false;
        }
        let selection, range;
        if (target.select) {
            const value = target.value;

            if (!value) {
                return false;
            }

            target.select();
        } else {
            selection = window.getSelection();
            range = document.createRange();

            range.selectNodeContents(target);
            selection.removeAllRanges();
            selection.addRange(range);

            if (range.collapsed) {
                return false;
            }
        }

        let error;

        try {
            document.execCommand('copy');
        } catch (reason) {
            error = reason;
        }

        if (!target.select) {
            range.collapse();
            selection = window.getSelection();
            selection.removeAllRanges();
        }

        return !error;
    }

    module.exports = copyToClipboard;
});
